(function (window, document) {
  function isCartPage() {
    return document.body && (
      document.body.classList.contains('cart') ||
      window.location.pathname === '/cart' ||
      window.location.pathname.indexOf('/cart/') === 0
    );
  }

  function revealImmediately() {
    if (isCartPage()) return;

    document.querySelectorAll('[data-aos]').forEach(function (element) {
      element.classList.add('aos-init', 'aos-animate');
      element.removeAttribute('data-aos');
      element.removeAttribute('data-aos-easing');
      element.removeAttribute('data-aos-duration');
      element.removeAttribute('data-aos-delay');
      element.removeAttribute('data-aos-once');
    });
  }

  window.AOS = {
    init: revealImmediately,
    refresh: revealImmediately,
    refreshHard: revealImmediately
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealImmediately);
  } else {
    revealImmediately();
  }
})(window, document);
